import React from 'react';

import Card from '../../components/common/Card';
import AdminLayout from '../../components/layout/AdminLayout';
import BucketListTable from '../../components/member/BucketListTable';

// The desktop page for the member's bucket list. The table itself is BucketListTable, which is
// also the Bucket list tab of the profile's golf lists, the phone's way in.
const BucketList: React.FC = () => (
  <AdminLayout
    activeMenuItem="/member/bucket-list"
    breadcrumbs={[
      { label: 'My Profile', href: '/member/profile' },
      { label: 'Bucket List', href: '#' },
    ]}
    allowedRoles={['User']}
  >
    <Card title="Bucket List">
      <BucketListTable />
    </Card>
  </AdminLayout>
);

export default BucketList;
